import { gql } from '@apollo/client';

const fetchCompanyBenefitTypesQuery = gql`
  query companyProfileCompanyBenefitCountryNames {
    companyProfileCompanyBenefitTypes {
      id
      titleSr
      titleEn
      inputExampleSr
      inputExampleEn
      iconClass
    }
  }
`;

export default fetchCompanyBenefitTypesQuery;
